// material-ui
import { Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';

// graphql
import FETCH_DEVICE_PROFILE from 'src/graphql/querys/fetchDeviceProfile';
import DELETE_DEVICE_PROFILE from 'src/features/deviceConfiguration/graphql/mutations/deleteProfile';

// redux
import { useMutation } from '@apollo/client';

// hooks
import { useModalStatusMessage } from 'src/hooks';

// components
import ActionButtons from 'src/components/ActionButtons';
import { useLingui } from '@lingui/react';
import { Trans, msg } from '@lingui/macro';

const DeleteDeviceProfile = ({ show, handleClose, device }) => {
  const { _ } = useLingui();
  const { openModalErrorMessage, openModalSuccessMessage } = useModalStatusMessage();
  const [deleteProfile, { loading, data, error }] = useMutation(DELETE_DEVICE_PROFILE, {
    refetchQueries: [FETCH_DEVICE_PROFILE],
  });

  const handleDelete = async () => {
    if (!device) return;

    try {
      const result = await deleteProfile({
        variables: {
          id: device.id,
        },
      });

      if (result.data.deleteDeviceProfile.success) {
        handleClose();
        openModalSuccessMessage(_(msg`Configuración eliminada correctamente`));
      } else {
        openModalErrorMessage(_(msg`Error al eliminar la configuración del equipo`));
      }
    } catch (e) {
      openModalErrorMessage(_(msg`Error al eliminar la configuración del equipo`));
    }
  };

  return (
    <Dialog open={show} onClose={() => handleClose()}>
      <DialogTitle>
        <Trans>Borrar configuración del equipo {device?.deviceProfile?.nameProject ?? ''}</Trans>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              <Trans>¿Estás seguro de que quieres borrar la configuración de este equipo?</Trans>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ActionButtons
              closeFunction={handleClose}
              actionFunction={handleDelete}
              actionButtonText={_(msg`Borrar`)}
              actionButtonColor="error"
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteDeviceProfile;
